let config = {
    BASEURL: '/api',
    BASEURLbeta: process.env.BASEURL || 'https://f5ce-2806-269-402-87d0-2d78-893b-2ce3-2ba2.ngrok.io',
    //localhost: 'http://localhost:5000'
}

export default config
